import Hero from "../components/Hero"
import FeaturesSection from "../components/FeaturesSection"
import ServicesSection from "../components/ServicesSection"
import EcommerceSection from "../components/EcommerceSection"
import TestimonialSection from "../components/TestimonialSection"
import TeamSection from "../components/TeamSection"
import NewsletterSection from "../components/NewsletterSection"
import CTASection from "../components/CTASection"
import FAQSection from "../components/FAQSection"

const Home = () => {
  
  return (
    <div>
      <Hero />
      <FeaturesSection />
      <ServicesSection />
      <EcommerceSection />
      <CTASection />
      <FAQSection />
      <TestimonialSection />
      <TeamSection />
      <NewsletterSection />
    </div>
  )
}

export default Home
